import script from "./ReturnStatusModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReturnStatusModal.vue?vue&type=script&setup=true&lang=ts"

import "./ReturnStatusModal.vue?vue&type=style&index=0&id=9d5fa8a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d5fa8a6"]])

export default __exports__